import { createAction, Action } from 'redux-actions';
export const actionTypesMaker = <T extends string = string>(
    namespace: string,
    actionTypes: T[]
) => {
    if (process.env.NODE_ENV === 'development') {
        const item = actionTypes.find((item) => item !== item.toUpperCase());
        if (item) {
            //
            throw new Error('wrong action **' + item + '**,action type must be UpperCase');
        }
    }
    return {
        [namespace.toUpperCase()]: actionTypes.reduce<{ [key in T]: string }>((p, c) => {
            p[c.toUpperCase()] = `@${namespace}/${c}`.toLowerCase();
            return p;
        }, {} as any),
    };
};

type actionGen = <T extends object>(payload: T) => Action<T>;

export function actionHelper(type: string): actionGen {
    return createAction(type);
}
